import * as Actions from "../actions";

const initialState = {
  open: false,
  collapsed: false,
};

export default function sidenavReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SET_SIDENAV:
      return { ...state, ...action.payload };
    case Actions.TOGGLE_SIDENAV:
      return { ...state, open: !state.open };
    case Actions.TOGGLE_SIDENAV_COLLAPSE:
      return { ...state, collapsed: !state.collapsed };
    default:
      return state;
  }
}
